import * as React from 'react';
import * as Glob from '../Globale';
import {Sessione, Lingua} from "../components/";

export class Footer extends React.Component<Glob.IGlobaleProps, {}> {
    public render() {
        return <footer className="footer kt-grid__item kt-footer overall">
            <div className="kt-container kt-container--fluid kt-container--full-height">
                <div className="footer-container">
                    <div className="footer-item footer-item--last">
                        <img src="/images/logo_colibri_footer.png" alt="Colibri"/>
                    </div>
                    <div className="footer-item footer-item--last" hidden>
                        <i>Session:</i> <Sessione {...this.props} />
                    </div>
                    <div className="footer-item footer-item--first">
                        <ul className="kt-footer__nav kt-nav kt-nav--inline kt--pull-right">
                            <li className="kt-nav__item kt-nav__item--sub">
                                <span className="kt-nav__link">
                                    <Lingua {...this.props} />
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>;
    }
}



// WEBPACK FOOTER //
// ./src/layout/Footer.tsx